/* eslint-disable */
import Epoxy from 'backbone.epoxy';

Epoxy.Model.prototype.recompute = function (attribute) {
    const self = this;
        let computeds;

    attribute = attribute || _.keys(self.computeds);

    if (_.isArray(attribute)) {
        _.each(attribute, (attr) => {
            if (self.hasComputed(attr)) {
                return self.c()[attr].get(true);
            }
        });
    } else if (attribute) {
        if (this.hasComputed(attribute)) {
            return this.c()[attribute].get(true);
        }
    }

    return null;
};

Epoxy.View = Epoxy.View.extend({
    bindingFilters: {
        empty(modelField, value) {
            return _.isEmpty(modelField, value);
        },
        equal(modelField, value) {
            return modelField === value;
        },
        wordEnding(number, value) {
            if (typeof number === 'number' || (typeof number === 'string' && parseInt(number, 10) == number)) {
                return number.wordEnding(value);
            }
                return false;
        },
        formatNumber(number) {
            if (_.isNumber(number)) {
                return number.formatNumber();
            }
        },
        length(collection) {
            return (collection !== null && collection?.length) ? collection.length : false;
        },
    },
    bindingHandlers: {
        htmlcondition($element, params) {
            $element.html(params[0] ? params[1] : params[2]);
        },
        animatedToggle: {
            set($element, params) {
                let value = params;
                let animationTime = 400;

                if (_.isArray(params)) {
                    [value, animationTime] = params;
                }
                $element.stop(false, true);

                if (!value) {
                    if ($element.is(':visible')) {
                        $element.slideUp(animationTime);
                    } else if (!$element.parent().is(':visible')) {
                        $element.hide();
                    }
                }
                if (!$element.is(':visible') && value) {
                    $element.slideDown(animationTime);
                }
            },
            get() {
            },
        },
        fadeToggle: {
            set($element, param) {
                let value = param;
                    let timeout = 400;
                if (_.isArray(value)) {
                    [value, timeout] = param;
                }

                if ($element.is(':visible') && !value) {
                    $element.fadeOut(timeout).addClass('hidden');
                }

                if (!$element.is(':visible') && value) {
                    $element.removeClass('hidden').fadeIn(timeout);
                }
            },
            get() {
            },
        },
        tempToggle: {
            set($element, param) {
                let value = param;
                    let timeout = 2500;
                if (_.isArray(value)) {
                    [value, timeout] = param;
                }
                clearTimeout($element.data('animationTimer'));
                if (!value) {
                    $element.hide();
                } else {
                    $element.show();
                    $element.data(
                        'animationTimer', setTimeout(() => {
                            $element.hide();
                        }, timeout),
                    );
                }
            },
            get() {
            },
        },
        toggleInlineBlock: {
            set($element, value) {
                if (value) {
                    $element.css('display', 'inline-block');
                } else {
                    $element.css('display', 'none');
                }
            },
            get() {
            },
        },
        delayedToggle: {
            set($element, param) {
                let value = param;
                    let timeout = 3000;
                if (_.isArray(value)) {
                    [value, timeout] = param;
                }
                clearTimeout($element.data('animationTimer'));
                if (value) {
                    $element.data(
                        'animationTimer', setTimeout(() => {
                            $element.show();
                        }, timeout),
                    );
                } else {
                    $element.hide();
                }
            },
            get() {
            },
        },
        fadeIn: {
            set($element, param) {
                let value = param;
                    let timeout = 400;
                if (_.isArray(value)) {
                    [value, timeout] = param;
                }

                $element.hide().fadeIn(timeout);
            },
            get() {
            },
        },
        event($element, eventParams) {
            $($element).on(eventParams[0], $.proxy(this.view[eventParams[1]], this.view));
        },
        set($element, eventParams) {
            const self = this;
            $($element).on(eventParams[0], () => {
                self.view.model.set(eventParams[1], eventParams[2]);
                return false;
            });
        },
        toggler($element, eventParams) {
            const self = this;
            $($element).on(eventParams[0], () => {
                const currentValue = self.view.model.get(eventParams[1]);
                self.view.model.set(eventParams[1], !currentValue);
                return false;
            });
        },
        setUnset(element, eventParams) {
            const self = this;
            $(element).on(eventParams[0], function () {
                let setValue;
                if ($(this).prop('checked')) {
                    setValue = eventParams[2];
                } else {
                    setValue = false;
                }
                self.view.model.set(eventParams[1], setValue);
            });
        },
        checkedSet(element, eventParams) {
            $(element).prop('checked', eventParams[2] == this.view.model.get(eventParams[1]));
            this.view.model.on(`${eventParams[0]}:${eventParams[1]}`, (model, value) => {
                $(element).prop('checked', value == eventParams[2]);
            });
        },
        clear(element, value) {
            if (!value) {
                $(element).empty();
            }
        },
    },
});
